import { Snackbar } from '@material-ui/core';

import styled from 'styled-components';

export const SnackBarStyled = styled(Snackbar)``;

export default {};
